/**
 * Phase 16 Plan 16-03 — WorkOrderStatusBadge
 *
 * Small presentational component mapping WorkOrderStatus values to shadcn Badge variants.
 *  Draft       → secondary (grey)
 *  Active      → default  (primary)
 *  Completed   → outline  (muted border)
 *  Cancelled   → destructive (red)
 */

import type { JSX } from 'react';

import { Badge } from '@/components/ui/badge';
import type { WorkOrderStatus } from '@/types/work-orders';

export interface WorkOrderStatusBadgeProps {
  readonly status: WorkOrderStatus;
}

type BadgeVariant = 'default' | 'secondary' | 'outline' | 'destructive';

const STATUS_VARIANT: Readonly<Record<WorkOrderStatus, BadgeVariant>> = {
  Draft: 'secondary',
  Active: 'default',
  Completed: 'outline',
  Cancelled: 'destructive',
};

export function WorkOrderStatusBadge({ status }: WorkOrderStatusBadgeProps): JSX.Element {
  return (
    <Badge
      variant={STATUS_VARIANT[status]}
      data-testid={`wo-status-badge-${status}`}
    >
      {status}
    </Badge>
  );
}
